__turbopack_context__.v({
  "appCaption": "oBNehG_appCaption",
  "appImage": "oBNehG_appImage",
  "appItem": "oBNehG_appItem",
  "applicationsGrid": "oBNehG_applicationsGrid",
  "applicationsHeader": "oBNehG_applicationsHeader",
  "applicationsSection": "oBNehG_applicationsSection",
  "brandSection": "oBNehG_brandSection",
  "colorBlack": "oBNehG_colorBlack",
  "colorBlue": "oBNehG_colorBlue",
  "colorComposition": "oBNehG_colorComposition",
  "colorHex": "oBNehG_colorHex",
  "colorLabel": "oBNehG_colorLabel",
  "colorLabelDark": "oBNehG_colorLabelDark",
  "colorOrange": "oBNehG_colorOrange",
  "colorRed": "oBNehG_colorRed",
  "colorWhite": "oBNehG_colorWhite",
  "metaBlock": "oBNehG_metaBlock",
  "metaGrid": "oBNehG_metaGrid",
  "metaLabel": "oBNehG_metaLabel",
  "metaLeft": "oBNehG_metaLeft",
  "metaOverview": "oBNehG_metaOverview",
  "metaRight": "oBNehG_metaRight",
  "metaSection": "oBNehG_metaSection",
  "metaText": "oBNehG_metaText",
  "metaTools": "oBNehG_metaTools",
  "outcomesSection": "oBNehG_outcomesSection",
  "page": "oBNehG_page",
  "processSection": "oBNehG_processSection",
  "radioPlayer": "oBNehG_radioPlayer",
  "resultDetail": "oBNehG_resultDetail",
  "resultItem": "oBNehG_resultItem",
  "resultLabel": "oBNehG_resultLabel",
  "resultValue": "oBNehG_resultValue",
  "resultsContent": "oBNehG_resultsContent",
  "resultsGrid": "oBNehG_resultsGrid",
  "resultsSection": "oBNehG_resultsSection",
  "socialGrid": "oBNehG_socialGrid",
  "socialItem": "oBNehG_socialItem",
  "socialSection": "oBNehG_socialSection",
  "storySection": "oBNehG_storySection",
  "streetFigure": "oBNehG_streetFigure",
  "streetGrid": "oBNehG_streetGrid",
  "streetMain": "oBNehG_streetMain",
  "streetSide": "oBNehG_streetSide",
  "videoCaption": "oBNehG_videoCaption",
  "videoContainer": "oBNehG_videoContainer",
  "videoSection": "oBNehG_videoSection",
});
